import { render, staticRenderFns } from "./Prob4.vue?vue&type=template&id=6e0af59f&scoped=true&"
import script from "./Prob4.vue?vue&type=script&lang=js&"
export * from "./Prob4.vue?vue&type=script&lang=js&"
import style0 from "./Prob4.vue?vue&type=style&index=0&id=6e0af59f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0af59f",
  null
  
)

export default component.exports